<template>
  <div>
    <a @click="showModal()" class="font-medium btn-view">
      View Code
    </a>
  </div>
</template>

<script>
export default {
  methods: {
    showModal () {
      this.$root.$emit('view-pixel-code-clicked', {
        url: this.params.data.postback_url,
        code: this.params.data.event_trigger_code
      })
      this.$gtag.event('Conversion_viewcode')
    }
  }
}

</script>

<style lang="scss" scoped>
  .btn-view {
    font-family: Poppins;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #0092d7;
    cursor: pointer;
  }

</style>
